import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import URLstateContext from "../../../provider/CommonContext";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../provider/ServiceProvider";
import product_riskometer from '../../../images/product_riskometer.png'
import animation from '../../../images/jm-animation.gif';
import renderHTML from 'react-render-html';
import './FundDetails.css';
function FundDetails(props) {
    const [data, setData] = useState(false);
    const [dataDown, setDataDown] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getSchemeCode = props.SchemeCode;
    let getSchemeType = props.SchemeDesc.split('-')[0];

    useEffect(() => {
        
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetFundDetails", {
            IVSchemeCode: getSchemeCode,
        }).then((data) => {
            
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
               
                setData(DecryptAESdata(data.data));
                setloadingshow(false);
            }

            // let res = DecryptAESdata(data.data)
            // console.log("responseeeeeeeeeeeeeeeeeeeeeee",res)
            
        });
        
        GetPostMethodData(BaseURL + "GetFundDownload", {
            IVSchemeCode: getSchemeCode,
        }).then((data) => {
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
                setDataDown(DecryptAESdata(data.data));
                setloadingshow(false);
            }
        });
    }, [BaseURL]);

    return (
        <>

            <section class="product_fund-details-sc" id="funds-details">
                <div class="section-heading">
                    Fund Details
                </div>
                {/* {loadingshow ? <div className="textcentervertex">
                    <img src={animation} alt="Loading" />
                    <div className="model_popup">Please Wait...</div>
                </div> : ""
                } */}
                <div class="gradiant-head-flex">

                    {/* {(data === false) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
                    {loadingshow ? (
                        <div className="textcentervertex HomeLoader">
                            <img src={animation} alt="Loading" />
                            <div className="model_popup">Please Wait...</div>
                        </div>
                    ) : (
                        <>
                            {data && data.length === 0 ? (
                                <h5 className="errormsgComNew">No Data Available</h5>
                            ) : (
                                <>
                                    {data && data.map(({ InvestmentObjective, categoryname, categorydesc, riskimage, riskdesc, risk, riskimagehover }) => (

                                        <div class="gradiant-head-box">
                                            <div class="gradiant-head-container">
                                                <h3 class="gradiant-head left">Investment Objective</h3>
                                            </div>
                                            <div class="gradiant-content">
                                                <p class="text-13 text-justify">{InvestmentObjective}</p>
                                                {/* <div class="investment-box">
                                                    <div class="head text-700 text-13">
                                                        Fund Type :
                                                        <span>
                                                            {categoryname}
                                                        </span>
                                                    </div>
                                                    <p class="text-13 mt-2">
                                                        {categorydesc}
                                                    </p>
                                                </div> */}
                                            </div>
                                        </div>



                                    ))
                                    }
                                    <div class="gradiant-head-box risk-meter">
                                        <div class="gradiant-head-container">
                                            <h3 class="gradiant-head left">Download Documents</h3>
                                        </div>
                                        {/* {loadingshow ? <div className="textcentervertex">
                                <img src={animation} alt="Loading" />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            } */}
                                        <div class="gradiant-content document-list">
                                            {/* {(dataDown === false) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
                                            {loadingshow ? (
                                                <div className="textcentervertex HomeLoader">
                                                    <img src={animation} alt="Loading" />
                                                    <div className="model_popup">Please Wait...</div>
                                                </div>
                                            ) : (
                                                <div>
                                                    {data && data.length === 0 ? (
                                                        <h5 className="errormsgComNew">No Data Available</h5>
                                                    ) : (
                                                        <ul>
                                                            {dataDown && dataDown.map(({ FileName, Title }, index) => {
                                                                
                                                                // Show item based on scheme type
                                                                const shouldShow =
                                                                    (getSchemeType === "Regular" && !Title.includes('Direct')) ||
                                                                    (getSchemeType === "Direct" && !Title.includes('Regular'));

                                                                return shouldShow ? (
                                                                    <li key={index}>
                                                                        <a
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            href={FileName}
                                                                        >
                                                                            {Title}
                                                                        </a>
                                                                    </li>
                                                                ) : null;
                                                            })}
                                                        </ul>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* </div> */}
                                    </div>
                                </>
                            )}
                        </>
                    )}
                    {/* <div class="gradiant-head-flex documents-container"> */}
                    {/*  {data && data.map(({ MinAddPurchase, MinSip, MinPurchase }) => (
                        <>
                            <div class="gradiant-head-box">
                                <div class="gradiant-head-container">
                                    <h3 class="gradiant-head left">Minimum Investment</h3>
                                </div>
                                <div class="gradiant-content investment-list">
                                    <ul>
                                        <li>Rs {MinPurchase} Lumpsum</li>
                                        <li>Rs {MinSip} SIP-12 instalments</li>
                                        <li>Rs {MinAddPurchase} Minimum Additional Purchase</li>
                                    </ul>
                                </div>
                            </div>
                        </>
                    ))} */}



                    {/* <div class="gradiant-head-box risk-meter">
                        <div class="gradiant-head-container">
                            <h3 class="gradiant-head">Download Documents</h3>
                        </div>
                        <div class="gradiant-content document-list">
                            {(dataDown === false) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''}
                            {dataDown && dataDown.map(({ FileName, Title }) => (
                                <>
                                    <ul>
                                        <li>
                                            <a target="_blank"
                                                rel="noreferrer"
                                                // href={BaseURL.replace("api/", "") + FileName}
                                                href={FileName}
                                            >{Title}</a>
                                        </li>
                                    </ul>
                                </>
                            ))}
                        </div>
                    </div> */}
                    {/* </div> */}
                </div >
                {data && data.map(({  categoryname, categorydesc }) => (

                    // <div class="gradiant-head-box">
                    //     <div class="gradiant-head-container">
                    //         <h3 class="gradiant-head left">Investment Objective</h3>
                    //     </div>
                    //     <div class="gradiant-content">
                    //         <p class="text-13">{InvestmentObjective}</p>

                    //     </div>
                    // </div>

                    <div class="investment-box">
                        <div class="head text-700 text-13">
                            Fund Type :
                            <span>
                                {categoryname}
                            </span>
                        </div>
                        <p class="text-13 mt-2">
                            {categorydesc}
                        </p>
                    </div>

                ))
                }
                {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
                {data && data.map(({ FundNature, categoryname, categorydesc, riskimage, riskdesc,schriskdesc, risk,schrisk,BmRiskImage,ShRiskImage, riskimagehover }) => (
                    // {data && data.map(({ FundNature, categoryname, categorydesc, riskimage, riskdesc, risk,BmRiskImage, riskimagehover,BenchmarkRiskometerText, SchemeRiskometerText })
                    <div class="gradiant-head-box risk-meter padding-top-plabel">
                        <div class="gradiant-head-container">
                            {/* <h3 class="gradiant-head">Scheme Risk-o-Meter</h3>    */}
                            <h3 class="gradiant-head">Product Label</h3>
                        </div>
                        <Tabs defaultActiveKey="schemes" transition={true} >
                            <Tab eventKey="schemes" title="Schemes">
                                <div className="product-label">

                                    <div className="product-label-content">
                                        {FundNature != null ? renderHTML(FundNature) : ''}
                                    </div>
                                    <div class="gradiant-content">
                                        <p class="text-xsm">Level of Risk {schrisk} in the fund</p>
                                        
                                        <div class="padding-box-inner text-center mt-1">
                                            <img src={riskimage} 
                                                alt="risk_image" className="riskimg" />
                                            <p class="text-13 textRisk">{schriskdesc}</p>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="benchmark" title="Benchmark">
                                <div className="product-label">
                                    <div className="product-label-content">
                                        {FundNature != null ? renderHTML(FundNature) : ''}
                                    </div>
                                    <div class="gradiant-content">
                                        <p class="text-xsm">Level of Risk {risk} in the fund</p>
                                        <div class="padding-box-inner text-center mt-1">
                                            <img src={BmRiskImage} 
                                                alt="risk_image" className="riskimg" />
                                            <p class="text-13 textRisk">{riskdesc}</p>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div >
                ))
                }

            </section >


         
            
            
        </>
    )

}

export default FundDetails